import React, { useRef, useState } from 'react';
import PlusIcon from '@heroicons/react/outline/PlusIcon.js';
import clsx from 'clsx';
import { nanoid } from 'nanoid';
import { Button } from '../Button/index.js';
import { SortableList } from '../SortableList/index.js';
import { LabelPickerItem } from './LabelPickerItem.js';
import { randomColor } from './utils.js';
export const LabelPicker = ({ value, onChange, placeholder, buttonLabel, invalid = false, disabled = false, itemSaveLabel, itemCancelLabel, }) => {
    const activatorNode = useRef(null);
    const [activeIndex, setActiveIndex] = useState(undefined);
    const [isNewItem, setNewItem] = useState(false);
    const [items, setItems] = useState(value !== null && value !== void 0 ? value : []);
    const handleChange = (newItems) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(newItems);
        setActiveIndex(undefined);
        setNewItem(false);
    };
    const addItem = () => {
        setItems(items => [
            {
                id: nanoid(),
                name: '',
                colorHex: randomColor(items.length),
            },
            ...items,
        ]);
        setActiveIndex(0);
        setNewItem(true);
    };
    const updateItem = (index, changes) => {
        const newItems = items.map((item, idx) => idx === index ? Object.assign(Object.assign({}, item), changes) : item);
        setItems(newItems);
        handleChange(newItems);
        focusActivatorNode();
    };
    const onRemove = (index) => {
        const newItems = [...items.slice(0, index), ...items.slice(index + 1)];
        setItems(newItems);
        handleChange(newItems);
    };
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const newItems = SortableList.reorder(items, result.source.index, result.destination.index);
        setItems(newItems);
        handleChange(newItems);
    };
    const focusActivatorNode = () => {
        requestAnimationFrame(() => {
            if (activatorNode.current == null) {
                return;
            }
            activatorNode.current.focus();
        });
    };
    return (React.createElement("div", { className: "flex flex-col space-y-3" },
        React.createElement("div", { className: "flex space-s-2" },
            React.createElement(Button, { ref: activatorNode, variant: "outline", leadingIcon: React.createElement(PlusIcon, null), size: "sm", className: clsx('shrink-0', invalid && 'border-line-negative'), onClick: addItem, disabled: disabled || activeIndex !== undefined }, buttonLabel || 'Add')),
        React.createElement(SortableList, { items: items, onDragEnd: onDragEnd, disabled: disabled || activeIndex !== undefined, renderItem: (item, index) => (React.createElement(SortableList.Item, { id: item.id },
                React.createElement("div", { className: "flex items-center space-s-2" },
                    React.createElement(SortableList.Handle, null),
                    React.createElement("div", { className: clsx('relative', 'grow truncate border border-line-subdued rounded-md p-2 px-3 bg-surface hover:bg-surface-hovered') },
                        React.createElement(LabelPickerItem, { item: item, active: activeIndex === index, onEdit: value => updateItem(index, value), onRemove: () => onRemove(index), onCancel: () => {
                                if (isNewItem) {
                                    onRemove(index);
                                }
                                setActiveIndex(undefined);
                                focusActivatorNode();
                            }, setActive: active => {
                                setActiveIndex(active ? index : undefined);
                            }, placeholder: placeholder, disabled: disabled ||
                                (activeIndex !== undefined && activeIndex !== index), saveLabel: itemSaveLabel, cancelLabel: itemCancelLabel }))))) })));
};
//# sourceMappingURL=LabelPicker.js.map